import { render, staticRenderFns } from "./BuscaAvancada.vue?vue&type=template&id=66ac552e&scoped=true"
import script from "./BuscaAvancada.vue?vue&type=script&lang=js"
export * from "./BuscaAvancada.vue?vue&type=script&lang=js"
import style0 from "./BuscaAvancada.vue?vue&type=style&index=0&id=66ac552e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ac552e",
  null
  
)

export default component.exports